import { useEffect, useRef } from 'react';
import './OurPurpose.css';
import Navigation from './Navigation';
import Footer from './Footer';

const OurPurpose = () => {
  const assetsBaseUrl = 'https://assets.bluestar-rowing.com/assets/our-purpose';
  const purposeBackground = `${assetsBaseUrl}/BLUE_STAR_ROWING_WEEKEND_1-44.jpg`;
  const gymPossibleImage = `${assetsBaseUrl}/v_2_01_05_25_01.jpg`;
  const gymPossibleWideImage = `${assetsBaseUrl}/v_2_01_04_59_23.jpg`;
  const visionGoalImage = `${assetsBaseUrl}/BSR_ROWING-73.jpg`;
  const gymPossibleVideo = `${assetsBaseUrl}/GYMPOSSIBLE_V_3_web.mp4`;
  const gymVideoRef = useRef(null);

  useEffect(() => {
    const video = gymVideoRef.current;
    if (!video) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.muted = false;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      },
      { threshold: 0.45 }
    );

    observer.observe(video);

    return () => {
      observer.unobserve(video);
      observer.disconnect();
    };
  }, []);

  return (
    <>
      <Navigation />
      <section className="our-purpose-page">
        <img
          src={purposeBackground}
          alt="Blue Star Rowing boat at sea"
          className="our-purpose-background-image"
        />
        <div className="our-purpose-background-overlay" />
        <div className="our-purpose-content">
          <h1 className="our-purpose-title">
            WHY ARE WE <span>ROWING</span>
          </h1>
          <p className="our-purpose-subtitle">... AND WHY WE NEED YOUR SUPPORT</p>
        </div>
      </section>

      <section className="our-purpose-support-pane">
        <div className="our-purpose-support-inner">
          <div className="our-purpose-support-copy">
            <h2 className="our-purpose-support-heading">
              OUR CHARITY
              <span>YOUR SUPPORT</span>
            </h2>
            <h3 className="our-purpose-support-title">Gym Possible</h3>
            <p className="our-purpose-support-founder">Founded by Drew Graham</p>
            <div className="our-purpose-support-divider" />
            <p className="our-purpose-support-text">
              A specialist gym space, purpose built for wheelchair users for anyone that has suffered a life changing
              spinal injury. This is currently no other facility in the North of England that offered a specialist
              environment like Gym Possible.
            </p>
            <a
              className="our-purpose-support-button"
              href="https://www.gympossible.co.uk"
              target="_blank"
              rel="noopener noreferrer"
            >
              ABOUT GYM POSSIBLE
            </a>
          </div>
          <div className="our-purpose-support-image-wrap">
            <img
              src={gymPossibleImage}
              alt="Gym Possible adaptive training session"
              className="our-purpose-support-image"
            />
          </div>
        </div>
      </section>

      <section className="our-purpose-video-pane">
        <video
          ref={gymVideoRef}
          className="our-purpose-video"
          controls
          autoPlay
          playsInline
          preload="metadata"
        >
          <source src={gymPossibleVideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </section>

      <section className="our-purpose-wide-image-pane">
        <img
          src={gymPossibleWideImage}
          alt="Gym Possible full width training scene"
          className="our-purpose-wide-image"
        />
      </section>

      <section className="our-purpose-vision-pane">
        <div className="our-purpose-vision-inner">
          <div className="our-purpose-vision-copy">
            <h2 className="our-purpose-vision-heading">
              OUR VISION
              <span>&amp; OUR GOAL</span>
            </h2>
            <p className="our-purpose-vision-lead">To create a state-of-the-art accessible gym.</p>
            <div className="our-purpose-vision-divider" />
            <p className="our-purpose-vision-text">
              Combining physiotherapy, counselling services, and a welcoming cafe, enabling disabled athletes to train
              for greater independence, fostering social connection and mental wellbeing.
            </p>
            <p className="our-purpose-vision-text">
              Our challenge is to row 3,000 miles to raise money and awareness for the charity and complete a
              monumental task known as the worlds toughest row.
            </p>
            <a
              className="our-purpose-vision-button"
              href="https://www.worldstoughestrow.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              THE WORLDS TOUGHEST ROW
            </a>
          </div>
          <div className="our-purpose-vision-image-wrap">
            <img
              src={visionGoalImage}
              alt="Blue Star Rowing team with Gym Possible"
              className="our-purpose-vision-image"
            />
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default OurPurpose;
